import BaseModel from "../models/BaseModel";

export default function PropertyViewHeader(props: { obj: BaseModel }) {
  const { obj } = props;
  const tagNeeded = obj.treeViewModel.getTagNeeded();
  const tag = obj.treeViewModel.getTag();
  let icon = obj.treeViewModel?.icon;

  return (
    <div className="ObjectPropertiesHeader">
      {icon} &nbsp; {tagNeeded && tag}&nbsp; {obj.nameOfDefaultName}
    </div>
  );
}
